import { ReactElement } from 'react';
import { Slider } from 'antd';
import { Volume2 } from 'lucide-react';
import { styled } from 'styled-components';

const VolumeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 48px);
  margin: 0 auto;
`;

const VolumeIcon = styled(Volume2)`
  width: 14px;
  height: 14px;
`;

const VolumeSlider = styled(Slider)`
  flex: 1;

  .ant-slider-rail,
  .ant-slider-track {
    height: 2px;
  }

  .ant-slider-handle {
    width: 10px;
    height: 10px;
  }
`;

const VolumeLabel = styled.span`
  font-size: 12px;
  color: #666;
  min-width: 36px;
  text-align: right;
`;

interface Props {
  volume: number;
  onChange: (value: number) => void;
}

const VolumeControl = ({ volume, onChange }: Props): ReactElement => {
  return (
    <VolumeRow>
      <VolumeIcon />
      <VolumeSlider value={volume} onChange={onChange} />
      <VolumeLabel>{volume}%</VolumeLabel>
    </VolumeRow>
  );
};

export default VolumeControl;
